module.exports = __webpack_public_path__ + "img/63.4cb93210.jpg";